import { TextField, TextFieldProps } from "@mui/material";
import { alpha } from "@mui/material/styles";

const CustomTextField: React.FC<TextFieldProps> = (props) => {
  const { sx: sxProp, InputLabelProps, InputProps, ...rest } = props;
  return (
    <TextField
      {...rest}
      variant="outlined"
      InputLabelProps={{
        ...InputLabelProps,
        sx: [
          ...(Array.isArray(InputLabelProps?.sx)
            ? (InputLabelProps?.sx ?? [])
            : InputLabelProps?.sx != null
            ? [InputLabelProps.sx]
            : []),
        ],
      }}
      InputProps={{
        ...InputProps,
        sx: [
          ...(Array.isArray(InputProps?.sx)
            ? (InputProps?.sx ?? [])
            : InputProps?.sx != null
            ? [InputProps.sx]
            : []),
          (theme) => ({
            backgroundColor: theme.palette.background.paper,
            borderRadius: "12px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor:
                theme.palette.mode === "light"
                  ? "#C79A61"
                  : alpha(theme.palette.common.white, 0.28),
              borderRadius: "12px",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor:
                theme.palette.mode === "light"
                  ? "#C79A61"
                  : alpha(theme.palette.common.white, 0.42),
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.secondary.main,
              borderWidth: 2,
            },
          }),
        ],
      }}
      sx={[
        (theme) => ({
          backgroundColor: theme.palette.background.paper,
          borderRadius: "12px",
          "& .MuiOutlinedInput-root": {
            backgroundColor: theme.palette.background.paper,
            borderRadius: "12px",
            color: theme.palette.text.primary,
          },
          "& .MuiInputLabel-root": {
            ...(theme.palette.mode === "dark" && {
              color: alpha(theme.palette.common.white, 0.75),
            }),
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: theme.palette.secondary.main,
          },
          "& input:-webkit-autofill": {
            boxShadow: `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
            WebkitTextFillColor: theme.palette.text.primary,
            borderRadius: "12px",
          },
        }),
        ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : []),
      ]}
    />
  );
};

export default CustomTextField;
